import React from "react";
import Back from "../common/back/Back";
import "./contact.css";

const Contact = () => {
  const map =
    "https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d31160.20457613009!2d76.65381482103418!3d12.295933164127815!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1652573352987!5m2!1sen!2sin";

  const handleInstagramClick = () => {
    window.open(
      "https://www.instagram.com/zentrixinfo/?igshid=c2RubTNhNmMxbjdk",
      "_blank"
    );
  };

  const handleWhatsAppClick = () => {
    window.open("https://chat.whatsapp.com/Dap3EXR5kza7YlfCDNG7OK", "_blank");
  };
  const handleform = () => {
    window.open("https://forms.gle/6mEo2sNPAecBn8SY6", "_blank");
  };

  return (
    <>
      <Back title="Contact us" />
      <section className="contacts padding">
        <div className="container shadow flexSB">
          <div className="left row">
            <iframe
              src={map}
              title="Mysore Location"
              frameBorder="0"
              allowFullScreen=""
              aria-hidden="false"
              tabIndex="0"
            ></iframe>
          </div>
          <div className="right row">
            <h1 style={styles.heading}>Contact us</h1>
            <p style={styles.description}>
              We're open for any suggestion or just to have a chat
            </p>

            <div className="items grid2">
              <div className="box">
                <h4>ADDRESS:</h4>
                <p>
                  Zentrix Pvt Ltd
                  <br />
                  Vijaynagar 3rd Stage
                  <br />
                  Mysore, Karnataka
                </p>
              </div>
              <div className="box">
                <h4>EMAIL:</h4>
                <p> infozentrixx@gmail.com</p>
              </div>
              <div className="box">
                <h4>PHONE:</h4>
                <p> +91 8660259075</p>
              </div>
              <div className="box">
                <h4>WHATSAPP GROUP:</h4>
                <p style={styles.whatsappLink} onClick={handleWhatsAppClick}>
                  Click here to join
                </p>

                <div className="box"></div>
                <h4>Fill form to callback</h4>
                <p style={styles.whatsappLink} onClick={handleform}>
                  Click here
                </p>
              </div>
            </div>

            <h3 style={styles.follow}>Follow us on Instagram</h3>
            <span style={styles.instagramLink} onClick={handleInstagramClick}>
              INSTAGRAM
            </span>
          </div>
        </div>
      </section>
    </>
  );
};

const styles = {
  heading: {
    fontSize: "2.5rem",
    marginBottom: "20px",
    fontFamily: "Arial, sans-serif",
    color: "#333", // Dark heading color
    textAlign: "center",
  },
  description: {
    fontSize: "1.2rem",
    lineHeight: "1.6",
    marginBottom: "20px",
    fontFamily: "Arial, sans-serif",
    color: "#555", // Slightly darker text color
    textAlign: "center",
  },
  follow: {
    fontSize: "1.5rem",
    marginBottom: "10px",
    fontFamily: "Arial, sans-serif",
    color: "#333", // Dark text color
    textAlign: "center",
  },
  instagramLink: {
    color: "#007bff", // Instagram link color
    textDecoration: "underline",
    cursor: "pointer",
    fontFamily: "Arial, sans-serif",
    textAlign: "center",
    display: "block",
  },
  whatsappLink: {
    color: "#007bff", // WhatsApp link color
    textDecoration: "underline",
    cursor: "pointer",
    fontFamily: "Arial, sans-serif",
    textAlign: "center",
  },
};

export default Contact;
